export const SET_HIVE_FETCH_ACTIVATED = 'SET_HIVE_FETCH_ACTIVATED';
export const SET_HIVE = 'SET_HIVE';
export const SET_AGV_FETCH_ACTIVATED = 'SET_AGV_FETCH_ACTIVATED';
export const SET_AGVS = 'SET_AGVS';
